import {useState, useEffect} from "react";
import axios from "axios";
import {base, locations_url, partners, projects_url, unit} from "../../../../api";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {Calendar} from "primereact/calendar";
import {AutoComplete} from "primereact/autocomplete";

const isDateField = variable => typeof variable === "string" && variable.includes("date");
const isNumberField = variable =>
	typeof variable === "string" &&
	(variable.includes("count") || variable.includes("number") || variable.includes("percentage"));
const isAutoCompleteField = variable =>
	["unit", "project_name", "location", "partner_name"].includes(variable);

const fetchData = async (url, setData) => {
	try {
		const response = await axios.get(url);
		setData(response.data);
	} catch (error) {
		console.error("Error fetching data", error);
	}
};

export default function DisabledFormFields({
	item,
	disabled,
	inputValues,
	handleInputChange,
	handleRemoveInput,
	remove,
}) {
	const [suggestions, setSuggestions] = useState([]);
	const [data, setData] = useState([]);
	const [inputValue, setInputValue] = useState(item.value || ""); // Initialize the value if needed

	const onInputChange = e => {
		const newValue = e.target.value;
		setInputValue(newValue);

		// Call the parent's handler with the updated value
		handleInputChange(item.property, newValue); // Correctly passing the property of the item
	};
	useEffect(() => {
		if (item.variable === "unit") fetchData(base + unit, setData);
		if (item.variable === "project_name") fetchData(base + projects_url, setData);
		if (item.variable === "location") fetchData(base + locations_url, setData);
		if (item.variable === "partner_name") fetchData(base + partners, setData);
	}, [item.variable]);

	const search = event => {
		const query = event.query || "";
		setSuggestions(data.filter(d => d.name && d.name.toLowerCase().includes(query.toLowerCase())));
	};

	return (
		<div key={item.variable} className="col-6 d-flex  align-items-center">
			{isDateField(item.variable) ? (
				<div className="col-11 mb-2">
					<label className="ps-2 mb-2 text-truncate " htmlFor={item.variable}>
						{item.variable_description}
					</label>
					<Calendar
						disabled={disabled}
						className="col-12 p-0"
						id={item.variable}
						value={inputValues[item.variable] || null}
						onChange={e => handleInputChange(item.variable, e.value)}
						showIcon
					/>
				</div>
			) : isNumberField(item.variable) ? (
				<div className="col-11 mb-2">
					<label className="ps-2 mb-2 text-truncate " htmlFor={item.variable}>
						{item.variable_description}
					</label>
					<InputNumber
						disabled={disabled}
						className="col-12 p-0"
						id={item.variable}
						value={inputValues[item.variable] || 0}
						onValueChange={e => handleInputChange(item.variable, e.value)}
					/>
				</div>
			) : isAutoCompleteField(item.variable) ? (
				<div className="col-11 mb-2">
					<label className="ps-2 mb-2 text-truncate " htmlFor={item.variable}>
						{item.variable_description}
					</label>
					<AutoComplete
						disabled={disabled}
						className="col-12 p-0"
						id={item.variable}
						value={inputValues[item.variable] || ""}
						suggestions={suggestions}
						completeMethod={search}
						field="project_name"
						onChange={e => handleInputChange(item.variable, e.value)}
					/>
				</div>
			) : (
				<div className="col-11 mb-2">
					<label className="ps-2 mb-2 text-truncate " htmlFor={item.variable}>
						{item.variable_description}
					</label>
					<InputText
						disabled={disabled}
						id={item.variable}
						value={inputValues[item.variable] || ""}
						onChange={e => handleInputChange(item.variable, e.target.value)}
					/>
				</div>
			)}
			{remove && (
				<Button
					icon="pi pi-trash"
					text
					rounded
					severity="danger"
					className="col-1 mt-3"
					onClick={() => handleRemoveInput(item)}
				/>
			)}
		</div>
	);
}
